export enum ViewTypes {
	day = 'Day',
	week = 'Week',
	month = 'Month'
}
export enum InputTypes {
	text = 'text',
	boolean = 'boolean',
	date = 'date',
	number = 'number',
	dateTime = 'dateTime',
	time = 'time',
	select = 'select'
}
